import { Pipe, PipeTransform } from '@angular/core';

import { environment } from '../../../environments/environment';
import { Address } from '../data/models/components/address';
import { AddressToStringPipe } from './address-to-string.pipe';

@Pipe({
  name: 'googleMapsImage',
})
export class GoogleMapsImagePipe implements PipeTransform {
  constructor(private addressToStringPipe: AddressToStringPipe) {}

  transform(address: Address): string {
    const _address = this.addressToStringPipe.transform(address);
    if (!_address) {
      return '';
    }
    const endpoint = `https://maps.googleapis.com/maps/api/staticmap?key=${environment.googleMapApiKey}`;
    const marker = `markers=${_address}`;
    return `${endpoint}&zoom=16&scale=1&size=600x600&type=roadmap&center=${_address}&${marker}`;
  }
}
